define.alias("shared/utils/time", "settings/utils/time");